<div class="document-title-row">
    <div class="document-title-col">
        <h1 class="head2">{{documentdata.title}}</h1>
    </div>
    <div class="document-close-col">
        <button class="btn-icon icon-disagree" role="button" tabindex="0" aria-label="Document sluiten" title="Document sluiten" (click)="close()"></button>
    </div>
</div>
<div class="document-content-row">
    <iframe *ngIf="useframeinline" [src]="frameurl">
    </iframe> 

    
      <ngx-extended-pdf-viewer *ngIf="usepdfjs"  [showOpenFileButton]="false" [showUnverifiedSignatures]="true"
                                [textLayer]="true"
                                  [showDownloadButton]="pdfDownloadAllowed" 
                                  [showBookModeButton]="false"
                                  [showSecondaryToolbarButton]="false"
                                  [showPrintButton]="pdfDownloadAllowed"
                                  [delayFirstView]="1000"
                                  [src]="pdfjsurl" 
                                  [height]="'100%'"
                                  [filenameForDownload]="pdfDownloadFilename"
                                  >
      </ngx-extended-pdf-viewer>
    

</div>
